var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508.2 390.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 245.92,
    y1: 3.15,
    x2: 245.92,
    y2: 390.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0f47"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,3.15c-21.75,21.97-21.04,63.75-7.17,89.67,20.81,38.87,65.16,54.11,80.63,95.37,13.49,36-2.99,61.28.57,96.43,3.96,39.11,45.99,53.49,79.97,55.53-31.64,3.1-52.38,23.48-78.34,37.16-79.9,42.12-83.84-32.6-157.11-37.21-56.14-3.54-116,2.68-172.55.05,38.39-9.41,52.93-50.4,80.67-72.83,29-23.44,59.17-25.58,88.99-42.01,68.38-37.67-7.12-69.75-11.75-104.6-5.08-38.28,38.88-74.71,15.08-110.56,13.26,1.69,30.37,3.6,43.55,2.05,10.78-1.28,24.57-6.97,37.45-9.05Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.92,340.15c-27.65-1.29-43.96-11-41.72-34.67.73-7.72,3.36-15.15,7.37-21.79L171.36,12.12c8.82-15.09,34.01-16.36,43.56-1.97,23.8,35.85-20.16,72.29-15.08,110.56,4.63,34.85,80.12,66.94,11.75,104.6-29.82,16.43-60,18.57-88.99,42.01-27.74,22.43-42.28,63.42-80.67,72.83Z",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92,340.15c-33.99-2.03-76.01-16.42-79.97-55.53-3.56-35.15,12.92-60.43-.57-96.43-15.47-41.26-59.82-56.5-80.63-95.37-13.87-25.91-14.59-67.7,7.17-89.67,11.06-1.78,20.86-5.61,30.65-.86,3.97,1.92,7.21,5.08,9.48,8.85l166.49,276.12c4.72,7.83,6.7,17.1,5.1,26.1-4.36,24.6-30.64,28.4-57.73,26.78Z",
    style: {
      fill: "#1c1c1c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowLogo);
export default __webpack_public_path__ + "static/media/flow_logo.348848b67a091374172cd46d15db3f53.svg";
export { ForwardRef as ReactComponent };